export default __webpack_public_path__ + "static/media/avatar_23.01bd8c62.png";